class Header {
  constructor(element) {
    this.element = element;
    this.toggle = element.querySelector("[data-header-toggle]");
    this.panel = element.querySelector("[data-header-panel]");
    this.pageContent = document.querySelectorAll("main, footer");
    this.mobileMedia = window.matchMedia("(max-width: 992px)");

    if (!this.toggle || !this.panel) {
      return;
    }

    this.handleToggle = this.handleToggle.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handlePanelClick = this.handlePanelClick.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);

    this.toggle.addEventListener("click", this.handleToggle);
    this.panel.addEventListener("click", this.handlePanelClick);
    document.addEventListener("keydown", this.handleKeydown);
    window.addEventListener("scroll", this.handleScroll, { passive: true });
    window.addEventListener("resize", this.handleResize, { passive: true });
    this.handleResize();
    this.handleScroll();
  }

  handleToggle() {
    this.setOpen(this.element.dataset.open !== "true");
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.setOpen(false);
      return;
    }

    if (event.key !== "Tab" || this.element.dataset.open !== "true") {
      return;
    }

    const focusableElements = [
      this.toggle,
      ...this.panel.querySelectorAll("a[href], button:not([disabled])"),
    ];
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  }

  handlePanelClick(event) {
    if (event.target.closest("a")) {
      this.setOpen(false, false);
    }
  }

  setOpen(isOpen, restoreFocus = true) {
    const isMobileOpen = this.mobileMedia.matches && isOpen;
    const label = isOpen
      ? this.toggle.dataset.headerLabelClose
      : this.toggle.dataset.headerLabelOpen;

    this.element.dataset.open = String(isOpen);
    this.toggle.setAttribute("aria-expanded", String(isOpen));
    this.panel.inert = this.mobileMedia.matches && !isOpen;
    this.pageContent.forEach((element) => {
      element.inert = isMobileOpen;
    });

    if (label) {
      this.toggle.setAttribute("aria-label", label);
    }

    if (isMobileOpen) {
      document.body.classList.add("no-scroll");
      if (window.lenisInstance) {
        window.lenisInstance.stop();
      }

      window.requestAnimationFrame(() => {
        const firstLink = this.panel.querySelector("a[href]");

        if (firstLink) {
          firstLink.focus();
        }
      });
    } else {
      document.body.classList.remove("no-scroll");
      if (window.lenisInstance) {
        window.lenisInstance.start();
      }

      if (restoreFocus && document.activeElement !== this.toggle) {
        this.toggle.focus();
      }
    }
  }

  handleResize() {
    if (window.innerWidth > 992 && this.element.dataset.open === "true") {
      this.setOpen(false, false);
      return;
    }

    this.panel.inert =
      this.mobileMedia.matches && this.element.dataset.open !== "true";
  }

  handleScroll() {
    if (this.element.dataset.open === "true") {
      return;
    }

    const currentScrollY = Math.max(0, window.scrollY);
    const hasLightBackground = document.body.classList.contains("single-article");

    if (currentScrollY > 50 || hasLightBackground) {
      this.element.classList.add("header--scrolled");
    } else {
      this.element.classList.remove("header--scrolled");
    }

  }
}

const header = document.querySelector("[data-header]");

if (header) {
  new Header(header);
}

export default Header;
